import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { PreAuthFooter } from '../components/PreAuthFooter';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/home');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-qc-bg flex flex-col items-center justify-center p-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-black text-qc-green tracking-tight mb-3">Get Green Light</h1>
          <p className="text-qc-text-dim text-base">Scan. Decide. Move on.</p>
        </div>

        <div className="bg-qc-surface rounded-3xl border border-qc-border p-6">
          <h2 className="text-2xl font-extrabold text-qc-text mb-6">Welcome back</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-qc-text-dim uppercase tracking-wider mb-2">
                Email
              </label>
              <Input
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="h-14 rounded-xl bg-qc-surface2 border-qc-border text-qc-text placeholder:text-qc-text-faint focus:border-qc-green focus-visible:ring-qc-green text-base"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-qc-text-dim uppercase tracking-wider mb-2">
                Password
              </label>
              <Input
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-14 rounded-xl bg-qc-surface2 border-qc-border text-qc-text placeholder:text-qc-text-faint focus:border-qc-green focus-visible:ring-qc-green text-base"
              />
            </div>
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-14 bg-qc-green hover:bg-qc-green-dark text-qc-bg rounded-xl font-extrabold text-base shadow-[0_8px_24px_rgba(0,230,118,0.25)] mt-2"
            >
              {loading ? 'Logging in...' : 'Log In'}
            </Button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-qc-text-dim">
            Don&apos;t have an account?{' '}
            <Link to="/signup" className="text-qc-green font-bold hover:text-qc-green-dark" data-testid="signup-link">
              Sign up
            </Link>
          </p>
        </div>

        <PreAuthFooter />
      </div>
    </div>
  );
}
